import { render, staticRenderFns } from "./LoginBackgroundComponent.vue?vue&type=template&id=1b193608&"
import script from "./LoginBackgroundComponent.vue?vue&type=script&lang=js&"
export * from "./LoginBackgroundComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoginBackgroundComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports